module.exports = __webpack_public_path__ + "static/media/jhon_and_george_thumb_wide.78bcb975.webp";